import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, DrawerBody, DrawerFooter, Text } from '@chakra-ui/react';

import { CypressIds } from '../../../../../../../../../../../constants/cypressIds';
import dataTypes from '../../../../../../../../../../../constants/dataTypes';
import { fieldInputTypes } from '../../../../../../../../../../../constants/fieldInputTypes';
import { Statuses } from '../../../../../../../../../../../constants/statuses';
import { createSuccessToast, createToast } from '../../../../../../../../../../../redux/modules/app';
import { hideTray } from '../../../../../../../../../../../redux/modules/tray';
import colors from '../../../../../../../../../../../styles/theme/foundation/colors';
import RequirementTemplateBlueprintType from '../../../../../../../../../../../types/RequirementTemplateBlueprintType';
import { isNullOrUndefined } from '../../../../../../../../../../../utils/validationUtil';
// eslint-disable-next-line import/no-cycle
import { REQUIREMENT_TYPES } from '../../../../../../../../../util/options';
// eslint-disable-next-line import/no-cycle
import { getUpdateRequirementTemplateBlockParams } from '../../../../../../../../../util/util';

import PolicyFieldValuesForm from './PolicyFieldValuesForm';

const SetPolicyFieldValuesForm = ({ blueprint }) => {
  const dispatch = useDispatch();
  const [showError, setError] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const currentTemplate = useSelector(blueprint.selectCurrentRequirementTemplate);

  const policyBlockData = useSelector(blueprint.selectCurrentRequirementTemplateBlock);

  const onSubmit = async data => {
    setSubmitting(true);
    if (currentTemplate.publishedAt) {
      dispatch(blueprint.updateChangesPublishedStatus(Statuses.Updating));
    }

    if (showError) setError(false);

    const updatedBooleanProperties = data[dataTypes.Boolean]?.map((value, id) => ({ id, value }))
      .filter(p => p.value) || [];

    const updatedMonetaryProperties = data[dataTypes.Monetary]?.map((value, id) => {
      const requiredValue = value?.split(/[$,]/)?.join('') ?? null;

      return { id, value: requiredValue };
    })?.filter(p => !isNullOrUndefined(p.value)) || [];

    const updatedAlphaNumericProperties = data[fieldInputTypes.AlphaNumeric]?.map((value, id) => {
      if (!value) {
        return { id, value: null };
      }

      return { id, value };
    }).filter(p => !isNullOrUndefined(p.value)) || [];

    const allUpdatedProperties = [...updatedBooleanProperties, ...updatedMonetaryProperties, ...updatedAlphaNumericProperties];

    const isEmptyPolicy = !allUpdatedProperties.length;

    if (isEmptyPolicy) {
      setError(true);
      return;
    }

    dispatch(createToast({
      title: 'Updating policy block',
      status: 'info'
    }));

    await dispatch(blueprint.updateRequirementTemplateBlock(
      policyBlockData[0].id,
      getUpdateRequirementTemplateBlockParams(
        policyBlockData[0].order,
        REQUIREMENT_TYPES.Policies,
        { requirementTemplateBlockProperties: allUpdatedProperties }
      )
    ));

    dispatch(createSuccessToast({
      title: 'Policy block updated',
      duration: 3000
    }));

    dispatch(blueprint.resetCurrentPolicyType());
    dispatch(blueprint.resetCurrentRequirementTemplateBlock());
    dispatch(hideTray());
    setSubmitting(false);
  };

  return (
    <>
      <DrawerBody>
        <PolicyFieldValuesForm blueprint={blueprint} formId="setPolicyFieldValuesForm" onSubmit={onSubmit} />
        {showError && (
        <Box mt={4}>
          <Text color={colors.error.primary['600']} textAlign="center" textStyle="bodyMd500">
            Policy must have at least one requirement property.
          </Text>
        </Box>
        )}
      </DrawerBody>
      <DrawerFooter>
        <Button
          data-cy={CypressIds.savePolicyRequirementDetailsButton}
          form="setPolicyFieldValuesForm"
          isDisabled={submitting}
          type="submit"
          width="100%"
        >
          Save Policy
        </Button>
      </DrawerFooter>
    </>
  );
};

SetPolicyFieldValuesForm.propTypes = { blueprint: RequirementTemplateBlueprintType };

export default SetPolicyFieldValuesForm;
